import { ConfigurationOntologyForAutomaticProtocolResponse } from '@/modules/configurationModule/detail/automation/protocols/services/configuration-ontology-for-automatic-protocol/configuration-ontology-for-automatic-protocol.dto'

export enum ConfigurationAutomationProtocolsModalTabIndex {
    BASIC = 0,
    PROTOCOLS = 1
}

export interface ConfigurationAutomationProtocolsModalState {
    ontologyForAutomaticProtocol: Partial<ConfigurationOntologyForAutomaticProtocolResponse>
    showProtocolsTab: boolean
    activeTabIndex: number
}
export const initialConfigurationAutomationProtocolsModalState =
    (): ConfigurationAutomationProtocolsModalState => ({
        ontologyForAutomaticProtocol: {},
        showProtocolsTab: false,
        activeTabIndex: ConfigurationAutomationProtocolsModalTabIndex.BASIC
    })
